// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux"; 
 
// const supersetUrl = 'http://13.233.232.249:8088';
 
// const SupersetDashboard = () => {

//   const auth = useSelector((state) => state.auth);
//   const username = auth.user?.username;
//   const email = auth.user?.user_email;
//   const roles = auth.user?.roles;
//   const id = auth.user?.id;

//   const superset_role_mapping = {"super_admin": "Admin", "organization_admin": "AP_Org_Admin"};

//   let supersetRole = "AP_User"; // Default

//   if (roles.includes("super_admin")) {
//     supersetRole = superset_role_mapping["super_admin"];
//   } else if (roles.includes("organization_admin")) {
//     supersetRole = superset_role_mapping["organization_admin"];
//   }
  
//   return (
//     <div className="App">
//       <iframe
//         src={`${supersetUrl}/login?token=123e4567-e89b-12d3-a456-426614174000&username=${id}&name=${username}&email=${email}&role=${supersetRole}&redirect=${supersetUrl}/superset/welcome`}
//         title="Superset Dashboard"
//         style={{ width: '100%', height: '100vh', border: 'none' }}
//       />
//     </div>
//   );
// };
 
// export default SupersetDashboard;




import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // <-- Important

const supersetUrl = 'http://13.233.232.249:8088';

const SupersetDashboard = () => {
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const username = auth.user?.username;
  const email = auth.user?.user_email;
  const roles = auth.user?.roles || [];
  const id = auth.user?.id;

  const superset_role_mapping = { "super_admin": "Admin", "organization_admin": "AP_Org_Admin" };

  let supersetRole = "AP_Org_Admin"; // Default
  if (roles.includes("super_admin")) {
    supersetRole = superset_role_mapping["super_admin"];
  } else if (roles.includes("organization_admin")) {
    supersetRole = superset_role_mapping["organization_admin"];
  }

  useEffect(() => {
    const url = `${supersetUrl}/login?token=123e4567-e89b-12d3-a456-426614174000&username=${id}&name=${username}&email=${email}&role=${supersetRole}&redirect=${supersetUrl}/superset/welcome`;
    
    window.open(url, '_blank'); // Open Superset in new tab
    navigate('/'); // <--- Immediately redirect user to home or dashboard or wherever you want
  }, [id, username, email, supersetRole, navigate]);

  return null; // 👈 no UI needed anymore!
};

export default SupersetDashboard;